import { IconButton, Paper, Tooltip } from '@mui/material';
import moment from "moment";
import { Component } from 'react';
import { connect } from 'react-redux';
import { confirmAction, showError, showMessage } from '../../../actions/uiActions';
import DomainsApi from '../../../api/domains';
import EmployerApi from '../../../api/employers';
import PaginatedTable from '../../../components/PaginatedTable';
import { withRouter } from '../../../utils/withRouter';
import CreateEmployerAdmin from './CreateAdmin';
import { Delete } from '@mui/icons-material';
import { Edit, Lock } from '@mui/icons-material';
import ResetUserPassword from '../../../components/ResetUserPassword';

class DomainAdmin extends Component {

  state = {
    loading: true,
    admin: null,
    admins: [],
    count: 0,
    page: 0,
    pages: 0,
    feins: [],
    form: {
      showForm: false,
      isEditing: false,
      selectedUser: null,
    },
    reset: false,
  }

  componentDidMount() {
    this.getAdmins(this.props.match.params.domainId);
    this.getDomainFeins(this.props.match.params.domainId)
  }

  getAdmins = async (domainId, page = 0) => {
    try {
      const result = await EmployerApi.getAdmins(domainId, page)
      if (result) {
        this.setState({ loading: false, admins: result.admins, page: result.page, pages: result.pages, count: result.count })
      }
    } catch (error) {
      this.setState({ loading: false })
      this.props.showMessage(error);
    }
  }

  toggleForm = (admin) => {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        showForm: !prevState.form.showForm,
        selectedUser: admin || null,
        isEditing: !!admin,
      }
    }));
  }

  getDomainFeins = async (domainId) => {
    try {
      let feins;
      const result = await DomainsApi.get(domainId)
      if (result.entities.length > 0) {
        feins = result.entities;
      }
      this.setState({
        feins: feins || []
      })
    } catch (error) {
      this.setState({ loading: false })
      showMessage(error);
    }
  }


  getEntityName = (feins) => {
    return (feins || []).map(each => {
      const selectedFein = this.state.feins.find(item => item.employer_fein === each);
      return (
        <p>
          {`${selectedFein ? selectedFein.employer_name : ""} (${each})`}
        </p>
      )
    }) || <></>
  }

  handleUpdateQuarterlyEmailPreference = async (id, quarterlyReportEnabled) => {
    try {
      await EmployerApi.updateAdmin(id, { quarterlyReportEnabled })
      await this.getAdmins(this.props.match.params.domainId);
    } catch (error) {
      this.props.showMessage(error ?? 'An error occurred')
    }
  }

  accountStatus = (admin) => {
    if (admin.deleted) return "Archived"
    if (admin.isActive) return "Active"
    return "Pending"
  }

  handleDeleteEmployer = async (employerId) => {
    try {
      const domainId = this.props.match.params.domainId
      await EmployerApi.deleteAdmin(employerId, domainId)
      this.props.showMessage("Admin user archived")
      await this.getAdmins(this.props.match.params.domainId);
    } catch (error) {
      this.props.showMessage(error ?? 'An error occurred')
    }
  }

  canShowResetPassword = (admin) => {
    return !admin.hasSso && !admin.deleted && admin.isActive;
  }

  render() {
    return (
      <div>
        <section className="animated fadeIn">
          <header>
            <h1>Domain Admin Management</h1>
          </header>

          <CreateEmployerAdmin
            feins={this.state.feins}
            domainId={this.props.match.params.domainId}
            getNewAdmin={this.getAdmins}
            form={this.state.form}
            toggleForm={this.toggleForm}
          />
          <div className="line-break"></div>
          <div className="row">
            <div className="col-12">
              <Paper>
                <PaginatedTable goToPage={(page) => this.getAdmins(this.props.match.params.domainId, page)} count={this.state.count} page={this.state.page} loading={this.state.loading} rows={this.state.admins.map(admin => {
                  return {
                    properties: {
                      key: admin._id
                    },
                    columns:
                      [
                        {
                          properties: {
                            key: `${admin._id}-1`
                          },
                          value: `${admin.email}`
                        },
                        {
                          properties: {
                            key: `${admin._id}-2`
                          },
                          value: `${admin.firstname} ${admin.lastname}`
                        },
                        {
                          properties: {
                            key: `${admin._id}-3`
                          },
                          value: `${admin.phone}`
                        },
                        {
                          properties: {
                            key: `${admin._id}-3`
                          },
                          value: this.getEntityName(admin.feins)
                        },
                        {
                          properties: {
                            key: `${admin._id}-4`,
                            className: `badge-container ${this.accountStatus(admin).toLowerCase()}`
                          },
                          value: <div>
                            {this.accountStatus(admin)}
                          </div>
                        },
                        {
                          properties: {
                            key: `${admin._id}-4`,
                            className: `badge-container ${admin.hasSso ? "active" : "pending"}`
                          },
                          value: <div>
                            <Tooltip title={admin.hasSso ? "This user logs in using your organization’s SSO" : "This user logs in using email and password"}>
                              {admin.hasSso ? "SSO Enabled" : "SSO Disabled"}
                            </Tooltip>
                          </div>
                        },
                        {
                          properties: {
                            key: `${admin._id}-5`
                          },
                          value: moment(admin.signup_date).format("MM/DD/YYYY")
                        },
                        {
                          properties: {
                            key: `${admin._id}-6`
                          },
                          value: (
                            <>
                              {!admin.deleted && <div>
                                {/* Edit */}
                                <Tooltip title="Edit Admin">
                                  <IconButton
                                    aria-label="Edit Admin"
                                    title="Edit Admin"
                                    onClick={() => this.toggleForm(admin)}
                                  >
                                    <Edit />
                                  </IconButton>
                                </Tooltip>
                                {/* Reset Password */}
                                {this.canShowResetPassword(admin) && <Tooltip title="Reset Password">
                                  <IconButton
                                    aria-label="Reset Password"
                                    title="Reset Password"
                                    onClick={() => this.setState({ reset: true, form: { ...this.state.form, selectedUser: admin } })}
                                  >
                                    <Lock />
                                  </IconButton>
                                </Tooltip>}

                                {/* Delete */}
                                <Tooltip title="Archive Admin">
                                  <IconButton
                                    aria-label="Archive Admin"
                                    title="Archive Admin"
                                    onClick={() => {
                                      this.props.confirmAction("Are you sure you want to archive this user? This will deactivate their account and they will no longer have access. You can restore their access later if needed.",
                                        () => this.handleDeleteEmployer(admin._id)
                                      );
                                    }}>
                                    <Delete color="error" />
                                  </IconButton>
                                </Tooltip>
                              </div>}
                            </>

                          )
                        },
                      ]
                  };
                })}
                  emptyMessage="No admin has been added"
                  columns={[
                    {
                      name: "Email",
                      properties:
                      {
                        key: 1,
                        className: "width10pct"
                      }
                    },
                    {
                      name: "Full name",
                      properties:
                      {
                        key: 2,
                        className: "width20pct"
                      }
                    },
                    {
                      name: "Phone Number",
                      properties:
                      {
                        key: 3,
                        className: "width10pct"
                      }
                    },
                    {
                      name: "FEIN",
                      properties:
                      {
                        key: 4,
                        className: "width10pct"
                      }
                    },
                    {
                      name: "Status",
                      properties:
                      {
                        key: 5,
                        className: "width10pct"
                      }
                    },
                    {
                      name: "SSO Status",
                      properties:
                      {
                        key: 6,
                        className: "width10pct"
                      }
                    },
                    {
                      name: "Created Date",
                      properties:
                      {
                        key: 7,
                        className: "width10pct"
                      }
                    },

                    {
                      name: "Actions",
                      properties:
                      {
                        key: 8,
                        className: "width10pct"
                      }
                    },
                  ]} />
              </Paper>
            </div>
          </div >
        </section >
        {
          this.state.reset && (
            <ResetUserPassword
              userType="employer_admin"
              id={this.state.form.selectedUser._id}
              onClose={() => this.setState({ reset: false })}
            />
          )
        }
      </div >
    )
  }
}

export default withRouter(connect(null, { showError, showMessage, confirmAction })(DomainAdmin));